import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {AuthComponent} from './auth.component';
import { AngularFireAuth } from '@angular/fire/auth';
import { Observable } from 'rxjs';
import { RegisterComponent } from './register/register.component';
import { AuthenticateComponent } from './authenticate/authenticate.component';
import { EscoComponent } from './esco/esco.component';
import { SuccessComponent } from './success/success.component';
import { AuthDetailsComponent } from './auth-details/auth-details.component';
import { AnonymousComponent } from './anonymous/anonymous.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { ResetPasswordConfermaComponent } from './reset-password-conferma/reset-password-conferma.component';

const routes: Routes = [
  {path: '', component: AuthComponent,  children: [

    {path: 'register',
    component:RegisterComponent
  },
    {path: 'authenticate',
     component:AuthenticateComponent
  },
    {path: 'reset',
    component:ResetPasswordComponent
  },
    {path: 'reset-conferma',
    component:ResetPasswordConfermaComponent
  },
    {path: 'esco',
    component:EscoComponent
  },
    {path: 'anonymous',
     component:AnonymousComponent
    },
        {path: 'success',
   component:SuccessComponent
   },
    {path: 'details/:id',
    component:AuthDetailsComponent
   }

  ]}

];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AuthRoutingModule {
  usr: Observable<firebase.User>;
  constructor(private afauth: AngularFireAuth) {

  this.usr = this.afauth.authState;
  routes[0].data = this.usr;
  }
}
